import { Box, Typography } from '@mui/material';

interface CategoryBoxProps {
  headerText: string;
  descText: string;
  onClick?: () => void;
  selected?: boolean;
}

const CategoryBox: React.FC<CategoryBoxProps> = ({ headerText, descText, onClick, selected }) => {
  return (
    <Box
      sx={{
        width: {xs: 250, md: 170},
        height: {xs: selected?140: 70 , md: 170},
        
        border: "2px solid #BAAA93",
        borderRadius: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        
        cursor: onClick ? "pointer" : "default",
        backgroundColor: selected ? "#7C4032" : "#fff",
        transition: "background-color 0.2s",
      }}
      onClick={onClick}
    >
      <Box  
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="body2"
          fontFamily={"Libre Baskerville, serif"}
          fontWeight={400}
          color={selected ? "#fff" : "#7C4032"}
          textAlign={"center"}
        >
          {headerText}
        </Typography>
        <Box my={1} />
        <Typography
          variant="body2"
          fontFamily={"Darker Grotesque"}
          fontWeight={400}
          color={selected ? "#fff" : "black"}
          textAlign={"center"}
          // sx={{ display: { xs: "none", md: "block" } }}
          display={selected? "block": "none"}
        >
          {descText}
        </Typography>
      </Box>
    </Box>
  );
};

export default CategoryBox;
